/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useContext, useEffect, useMemo, useState } from 'react'
import {
    Button,
    ExpandMoreRoundedIcon,
    FileUploadRoundedIcon,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Typography,
} from '../../../components/shared/MaterialUI'
import moment from 'moment';
import { useSelector } from 'react-redux';
import { debounce } from 'lodash';
import { Autocomplete, TextField } from '@mui/material';

// @assets
import { MenuProps } from '../../../assets/css/tableComponents-styles'
import { DashboardStyles } from '../../../assets/css/dashboard-style';
import { theme } from '../../../assets/theme';
import { GeneralStyles } from '../../../assets/css/general-style';

// @helpers
import { formDataUploadEmployees, getOrganizations } from '../../../helpers/FunctionsUtils';
import AppHelper from '../../../helpers/AppHelper';
import { LISTROLES } from '../../../helpers/ListRoles';

// @context
import { useUI } from '../../../app/context/ui';
import { FilePageContext } from '../FilePage';

// @services
import EmployeeCompanyServiceNewApi from '../../../services/newApi/EmployeeCompanyServiceNewApi';
import CompanyServiceNewApi from '../../../services/newApi/CompanyServiceNewApi';
import PayrollService from '../../../services/newApi/PayrollService';

const UploadFile = () => {
    const gState = useSelector((state) => state);
    const organization = gState?.organizationReducer?.organizationSelected;
    const styles = useMemo(() => DashboardStyles(), []);
    const generalStyle = useMemo(() => GeneralStyles(), []);
    const employeeServiceNewApi = useMemo(() => new EmployeeCompanyServiceNewApi(), []);
    const companyServiceNewApi = useMemo(() => new CompanyServiceNewApi(), []);
    const payrollService = useMemo(() => new PayrollService(), []);
    const [fileSelected, setFileSelected] = useState("");
    const { blockUI, snackbarUI } = useUI();
    const [organizationList, setOrganizationList] = useState([]);
    const [valueCompany, setValueCompany] = useState();
    const [inputValue, setInputValue] = useState('');
    const [listCompanies, setListCompanies] = useState([]);
    const [orgSelected, setOrgSelected] = useState('');
    const { fetchFiles } = useContext(FilePageContext);

    const fileOptions = [
        {
            id: 1,
            label: 'Add employer',
            fileName: `Uploaded-employers-${moment().format('MM-DD-YYYY')}.csv`,
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter]
        },
        {
            id: 2,
            label: 'Update employer',
            fileName: `Uploaded-employers-${moment().format('MM-DD-YYYY')}.csv`,
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter]
        },
        {
            id: 3,
            label: 'Add employees',
            fileName: `created_employees_list_${moment().format('MM-DD-YYYY')}.csv`,
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter, LISTROLES.employerManager, LISTROLES.employerReporter]
        },
        {
            id: 4,
            label: 'Update employees',
            fileName: `updated_employees_list_${moment().format('MM-DD-YYYY')}.csv`,
            roles: [LISTROLES.superAdmin]
        },
        {
            id: 5,
            label: 'Update state certification',
            fileName: `updated_state_certification_${moment().format('MM-DD-YYYY')}.csv`,
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter]
        },
        {
            id: 6,
            label: 'NSI',
            fileName: `result_nsi_employees_${moment().format('MM-DD-YYYY')}.csv`,
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter, LISTROLES.employerManager, LISTROLES.employerReporter]
        },
        {
            id: 7,
            label: 'Update NSI',
            fileName: `updated_NSI_files_${moment().format('MM-DD-YYYY')}.csv`,
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter]
        },
        {
            id: 8,
            label: 'Payroll',
            fileName: `result_payroll_employees_${moment().format('MM-DD-YYYY')}.csv`,
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter, LISTROLES.employerManager, LISTROLES.employerReporter]
        },
        {
            id: 9,
            label: 'Bulk import',
            fileName: `created_employees_list_${moment().format('MM-DD-YYYY')}.csv`,
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter, LISTROLES.employerManager, LISTROLES.employerReporter]
        },
    ];

    const filteredMenu = fileOptions.filter(item => item.roles.includes(gState?.user.role));

    const handleUploadFile = () => {
        const file = document.getElementById('upload-dynamic-file');
        file.click();
    }

    const getCompanyId = () => {
        const company = listCompanies?.find(company => company?.name === valueCompany);
        return company?.id;
    }

    const fileActions = {
      1: (file) => companyServiceNewApi.addEmployerByFile(file, organization?.id),
      2: (file) => companyServiceNewApi.updateEmployerByFile(file),
      3: (file) => employeeServiceNewApi.chargeCsvFile(file, getCompanyId()),
      4: (file) => employeeServiceNewApi.updateEmployeesByCsv(file),
      5: (file) => employeeServiceNewApi.uploadFileUpdateNsi(file, true),
      6: (file) => employeeServiceNewApi.updateEmployeesByNsi(file),
      7: (file) => employeeServiceNewApi.uploadFileUpdateNsi(file, false),
      8: (file) => payrollService.uploadManual(file),
      9: (file) => employeeServiceNewApi.chargeCsvFile(file, getCompanyId()),
    };

    const uploadFile = (e) => {
      const file = e.target.files[0];
      if (file) {
        const formData = formDataUploadEmployees(file);
        const action = fileActions[fileSelected];
        if (action) submitFile(e, action(formData));
      }
    };

    const submitFile = async (e, serviceCall) => {
        try {
            await serviceCall;
            resetForm();
            fetchFiles();
            snackbarUI.current.open('Records were uploaded successfully!');
        } catch (err) {
          throwError(err);
          e.target.value = "";
        }
    }

    const resetForm = () => {
        setFileSelected('');
        setInputValue('');
        setValueCompany();
        setOrgSelected('');
        setListCompanies([]);
    }

    const throwError = (error) => {
        blockUI.current.open(false);
        if(typeof error?.response?.data === 'string' && error?.response?.data?.includes('Error processing the CSV file') )return errorInvalidFile();
        if(error?.response?.data?.errors && error?.response?.data?.errors[0]?.includes('Error processing the CSV file') )return errorInvalidFile();
        if(typeof error?.response?.data === 'string' && error?.response?.status === 400 )return errorInvalidFile(error?.response?.data);
        AppHelper.checkError(error, snackbarUI);
    }

    const errorInvalidFile = (error) => {
        snackbarUI.current.open(error ??'Error processing the CSV file, verify that the structure is correct.');
    }

    const getOrganization = async () => {
        try {
            const params = {snackbarUI, blockUI, loading:false, status: true}
            const response = await getOrganizations(params);
            setOrganizationList(response?.data?.data);
        } catch (error) {
            AppHelper.checkError(error, snackbarUI);
        }
    }

    const handleChangeEmployer = debounce((query) => {
        if(!orgSelected)return;
        if(query?.length > 1)getAllCompanies(orgSelected, {name: query});
        if(!query)getAllCompanies(orgSelected);
    }, 500);

    const getAllCompanies = async (org, filters={}) => {
        const sort = {order: true, direction: 'asc' }
        try {
          blockUI.current.open(true);
          const response = await companyServiceNewApi.getCompanies({page:1, size:1000}, org, filters, sort);
          setListCompanies(response?.data?.data);
          blockUI.current.open(false);
        } catch (error) {
          blockUI.current.open(false);
          AppHelper.checkError(error, snackbarUI);
        }
    }

    useEffect(() => {
        getOrganization();
    }, [])

    const handleChangeFile = (e) => {
        setFileSelected(e.target.value);
        setInputValue('');
        setValueCompany();
        setOrgSelected('');
        setListCompanies([]);
    }

    const showButtonUpload = () => {
        if(!fileSelected) return false;
        if(fileSelected === 3 || fileSelected === 9 ){
            if(!orgSelected || !valueCompany) return false;
            return true;
        }
        return true;
    }

  return (
    <Paper
        disableGutters
        sx={{
            boxShadow: '0px 2px 4px 2px rgb(36 35 35 / 15%)',
            borderRadius: '5px',
            padding: '20px',
            boxSizing: 'border-box !important',
            backgroundColor: theme.palette.primary.white,
            width: '100%',
            marginBottom: '20px'
        }}
    >
        <Grid
            container
            spacing={2}
            direction="row"
            alignItems="center"
        >
            <Grid item xs={12} md={1.5}>
                <Typography variant="h6" style={{color: theme.palette.primary.black}}>Select File</Typography>
            </Grid>

            <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                    <InputLabel id="selectFile">Select File</InputLabel>
                    <Select
                        value={fileSelected}
                        label="Select File"
                        IconComponent={ExpandMoreRoundedIcon}
                        onChange={(e) => { handleChangeFile(e) }}
                        sx={{...styles.statusSelect, ...styles.statusSelectSecondary}}
                        MenuProps={MenuProps}
                    >
                        <MenuItem value="" >Select</MenuItem>
                        {filteredMenu.map((st) => (
                            <MenuItem
                                value={st.id}
                                key={st.id}
                            >
                                {st.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            {
                (fileSelected === 3 || fileSelected === 9) && 
                <>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <InputLabel id="selectOrganization">Organization</InputLabel>
                            <Select
                                value={orgSelected}
                                label="Organization"
                                id='selectOrganization'
                                name='selectOrganization'
                                IconComponent={ExpandMoreRoundedIcon}
                                onChange={(e)=> {
                                    setOrgSelected(e.target.value);
                                    setInputValue('')
                                    setValueCompany();
                                    getAllCompanies(e.target.value);
                                }}
                                sx={{...styles.statusSelect, ...styles.statusSelectSecondary}}
                                MenuProps={MenuProps}
                            >
                            {React.Children.toArray(
                                organizationList &&
                                organizationList?.map((item, index) => (
                                    <MenuItem
                                        value={item.id}
                                        key={index}
                                    >
                                        {item.name}
                                    </MenuItem>
                                ))
                            )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <Autocomplete
                                id="employerName"
                                freeSolo
                                size='medium'
                                value={valueCompany}
                                onChange={(event, newValue) => { setValueCompany(newValue) }}
                                inputValue={inputValue}
                                onInputChange={(event, newInputValue) => {setInputValue(newInputValue)}}
                                name='nameEmployer'
                                options={listCompanies.map((option) => option.name)}
                                sx={styles.autocompleteField}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Employer Name"
                                    sx={{...styles.statusSelect, ...styles.statusSelectSecondary}}
                                    onChange={(e) => handleChangeEmployer(e.target.value)}
                                    InputProps={{
                                    ...params.InputProps,
                                    type: 'search',
                                    }}
                                />
                                }
                            />
                        </FormControl>
                    </Grid>
                </>
            }

            {showButtonUpload() && <Grid item xs={12} md={2}>
                <Button
                    sx={{
                        ...generalStyle.customButton,   
                        ...generalStyle.customButtonSm,
                        height: "50px"
                    }}
                    endIcon={<FileUploadRoundedIcon />}
                    onClick={handleUploadFile}
                >
                    Upload csv file
                </Button>
            </Grid>}
        </Grid>

        <input
            type='file'
            accept=".csv"
            id="upload-dynamic-file"
            style={{display: 'none'}}
            onChange={(e) => uploadFile(e)}
        />
    </Paper>
  )
}

export default UploadFile